import script from "./recipe-actions-button.vue?vue&type=script&setup=true&lang=js"
export * from "./recipe-actions-button.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__